import {
  isNumber,
  isString,
  isArray,
  isNull,
  isUndefined,
} from '@/utils/checkers/validation'

export const isEmpty = (obj: unknown): boolean => {
  if (isNull(obj) || isUndefined(obj)) {
    return true
  }

  if (isArray(obj) || isString(obj)) {
    return obj.length === 0
  }

  if (isNumber(obj)) {
    return !obj
  }

  return Object.keys(obj).length === 0
}

// Note: the type of `{}` is not `{}`, which is the type of all values except null and undefined.
export type EmptyObject = Record<string, never>

export const isEmptyObject = (value: unknown): value is EmptyObject =>
  typeof value === 'object' && value !== null && Object.keys(value).length === 0
